import React from "react";
import { createRoot } from "react-dom/client";
import { CookiesProvider } from "react-cookie";
import { Provider as ReduxProvider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import store from "./store";
import App from "./App";
import { createTheme, CssBaseline, Slide, ThemeProvider } from "@mui/material";
import { SnackbarProvider } from "notistack";

const root = createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <CookiesProvider>
            <ReduxProvider store={store}>
                <ThemeProvider
                    theme={createTheme({
                        palette: {
                            primary: {
                                main: "#4caf50",
                                background: "#e8f5e9",
                            },
                            variant: "#eceff1",
                        },
                    })}
                >
                    <SnackbarProvider
                        maxSnack={3}
                        preventDuplicate
                        TransitionComponent={Slide}
                        anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                        }}
                    >
                        <BrowserRouter >
                            <CssBaseline />
                            <App />
                        </BrowserRouter>
                    </SnackbarProvider>
                </ThemeProvider>
            </ReduxProvider>
        </CookiesProvider>
    </React.StrictMode>
);
